import { PersistentStore } from 'utils/persistent-store';
import { create } from 'zustand';

const emptyState: State = {
  productName: '',
  productDescription: '',
  productPrice: '',
  productImages: ['https://americanbarbell.com/cdn/shop/products/Mockup_yogamats_v01.jpg'],
  shouldAddSingleProductToStore: false,
  isMediaLoading: false,
};

const storage = new PersistentStore<State>('stores-onboarding-app-product-state', emptyState);

type State = {
  productName: string;
  productDescription: string;
  productPrice: string;
  productImages: string[];
  generatedProductName?: string;
  generatedProductDescription?: string;
  generatedProductPrice?: number;
  shouldAddSingleProductToStore: boolean;
  isMediaLoading: boolean;
};

type Store = State & {
  setProductName: (productName: State['productName']) => void;
  setProductDescription: (productDescription: State['productDescription']) => void;
  setProductPrice: (productPrice: State['productPrice']) => void;
  setProductImages: (productImages: State['productImages']) => void;
  setGeneratedProductName: (generatedProductName: State['generatedProductName']) => void;
  setGeneratedProductDescription: (generatedProductDescription: State['generatedProductDescription']) => void;
  setGeneratedProductPrice: (generatedProductPrice: State['generatedProductPrice']) => void;
  setShouldAddSingleProductToStore: (shouldAddSingleProductToStore: State['shouldAddSingleProductToStore']) => void;
  setIsMediaLoading: (isMediaLoading: State['isMediaLoading']) => void;
  reset: () => void;
};

export const useProductStore = create<Store>()((set) => ({
  ...storage.getState(),
  setProductName: (productName) => set({ productName }),
  setProductDescription: (productDescription) => set({ productDescription }),
  setProductPrice: (productPrice) => set({ productPrice }),
  setProductImages: (productImages) => set({ productImages }),
  setGeneratedProductName: (generatedProductName) => set({ generatedProductName }),
  setGeneratedProductDescription: (generatedProductDescription) => set({ generatedProductDescription }),
  setGeneratedProductPrice: (generatedProductPrice) => set({ generatedProductPrice }),
  setShouldAddSingleProductToStore: (shouldAddSingleProductToStore) => set({ shouldAddSingleProductToStore }),
  setIsMediaLoading: (isMediaLoading) => set({ isMediaLoading }),
  reset: () => set(emptyState),
}));

useProductStore.subscribe((state) => {
  storage.setState(state);
});
